import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { on, addClass, selectAll, openModal, removeClass } from 'helpers/dom'
import { map } from 'helpers/utils'

const selectors = {
  CLOSE_SELECTOR: '.js-close-modal-dialog',
  CONTENT_SELECTOR: '.js-content-modal-dialog',
  OPEN_CLASS: 'modal-dialog-opened',
  OVERLAY_CLASS: 'modal-dialog-overlay',
  VALIDATE_FORM_CLASS: 'validate-form'
}

class ModalDialog extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  init() {
    this.closeBtn = this.querySelectorAll(selectors.CLOSE_SELECTOR)
    this.contentEl = this.querySelector(selectors.CONTENT_SELECTOR)
    this.isSlideOut = this.dataset && this.dataset.type === 'slideout'
    this.scrollTarget = this.getAttribute('data-scroll-target')
    this.attachEvents()
    this.addOverlay()
  }

  attachEvents() {
    this.closeBtn.forEach((btn) => on('click', this.hide.bind(this), btn))
    on('click', this.hide.bind(this), this)
    this.contentEl && on('click', (e) => e.stopPropagation(), this.contentEl)
    on(
      'keyup',
      (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE') this.hide()
      },
      this
    )
  }

  addOverlay() {
    if (this.isSlideOut && !this.overlayEl) {
      this.overlayEl = document.createElement('div')
      addClass(selectors.OVERLAY_CLASS, this.overlayEl)
      this.insertBefore(this.overlayEl, this.contentEl)
    }
  }

  show(target, init = false) {
    init && this.init()
    /** Hide all opened modal before open new modal */

    const allModals = document.querySelectorAll(selectors.OPEN_CLASS)

    allModals.forEach((modal) => modal.hide())

    this.setAttribute('open', '')
    this.classList.add(selectors.OPEN_CLASS)

    if (!target) {
      const scrollTargetEl = selectAll(this.scrollTarget, this)

      map(disableBodyScroll, [...scrollTargetEl, this.contentEl])
    } else {
      disableBodyScroll(target)
    }

    this.dispatchEvent(new Event('open-modal'))
    addClass('modal-open', document.body)
  }

  hide() {
    /** Refresh validate form when hide modal */
    const allFormsValidate = this.querySelectorAll(selectors.VALIDATE_FORM_CLASS)

    allFormsValidate.forEach((form) => form.refreshValidate())

    this.removeAttribute('open')
    this.classList.remove(selectors.OPEN_CLASS)

    const allOpenModals = document.getElementsByClassName(selectors.OPEN_CLASS)

    if (allOpenModals.length === 0) {
      clearAllBodyScrollLocks()
    }

    this.dispatchEvent(new Event('close-modal'))
    removeClass('modal-open', document.body)
    removeClass('rebuy-modal-visible', document.body)
    clearAllBodyScrollLocks()
  }
}

customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    this.idTrigger = this.getAttribute('data-id')
    this.attachEvents()
  }

  attachEvents() {
    this.addEventListener('click', () => openModal(this.idTrigger, false))
    this.addEventListener('keydown', (e) => {
      if (e.keyCode === 13 && !e.shiftKey) {
        openModal(this.idTrigger, false)
      }
    })
  }
}

customElements.define('modal-opener', ModalOpener)
